import { FollowOnModelTotalDTO } from './FollowOnModelTotalDTO';
import { FollowOnPortfolioDTO } from './FollowOnPortfolioDTO';

export class ModelForTableDTO {
  models: FollowOnPortfolioDTO[] = [];
  showModels = true;
  total: FollowOnModelTotalDTO = new FollowOnModelTotalDTO();
}
